// src/components/Navbar.jsx
import {
    AppBar,
    Toolbar,
    Button,
    Box,
    Container,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
    const location = useLocation();
    const [open, setOpen] = useState(false);

    const navItems = [
        { label: "Accueil", path: "/" },
        { label: "Calendrier", path: "/calendrier" },
        { label: "Prestations", path: "/prestations" },
        { label: "À propos", path: "/a-propos" },
        { label: "Jobs", path: "/jobs" },

    ];

    return (
        <>
            <AppBar
                position="static"
                color="transparent"
                elevation={0}
                sx={{
                    borderBottom: "1px solid #e5e5e5",
                    backgroundColor: "#ffffff",
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

                        {/* Logo */}
                        <Box
                            component="img"
                            src="../logo/logo.png"
                            alt="321 Timing"
                            height={55}
                            sx={{ cursor: "pointer" }}
                            onClick={() => (window.location.href = "/")}
                        />

                        {/* Desktop Navigation */}
                        <Box sx={{ display: { xs: "none", md: "block" } }}>
                            {navItems.map((item) => (
                                <Button
                                    key={item.path}
                                    component={Link}
                                    to={item.path}
                                    sx={{
                                        color:
                                            location.pathname === item.path
                                                ? "secondary.main"
                                                : "primary.main",
                                        fontWeight: location.pathname === item.path ? 700 : 400,
                                        mx: 1,
                                    }}
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </Box>

                        {/* Mobile Menu Button */}
                        <IconButton
                            sx={{ display: { xs: "block", md: "none" } }}
                            onClick={() => setOpen(true)}
                        >
                            <MenuIcon sx={{ color: "primary.main" }} />
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* Drawer Mobile */}
            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <Box sx={{ width: 250, mt: 4 }}>
                    <List>
                        {navItems.map((item) => (
                            <ListItem key={item.path} disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to={item.path}
                                    onClick={() => setOpen(false)}
                                >
                                    <ListItemText
                                        primary={item.label}
                                        primaryTypographyProps={{
                                            color:
                                                location.pathname === item.path
                                                    ? "secondary.main"
                                                    : "primary.main",
                                            fontWeight: location.pathname === item.path ? 700 : 400,
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
}
